
<template>
<!-- 答题卡考生信息 -->
  <div class="modal-basics-info">
    <el-dialog
      title="考生信息"
      :visible.sync="dialogVisible"
      width="30%"
      @close="closeDialog"
      append-to-body
      >
      <el-checkbox-group v-model="checkList" style="margin: 20px 0">
        <el-checkbox label="姓名"></el-checkbox>
        <el-checkbox label="学校"></el-checkbox>
        <el-checkbox label="班级"></el-checkbox>
        <el-checkbox label="考号" ></el-checkbox>
        <el-checkbox label="专业" ></el-checkbox>
        <el-checkbox label="考场" ></el-checkbox>
        <el-checkbox label="座位" ></el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <span style="margin-right: 293px; font-size: 14px; color: red">请选择4-5项</span>
        <el-button @click="handleCancel('cancel')">取 消</el-button>
        <el-button type="primary" @click="handleSubmit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AcCardApi from "@/services/acCard"
import { mapState, mapMutations } from "vuex";
export default {
  props:{
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
  ...mapState("card", {
    basicsCheckList: (state) => state.basicsCheckList, //选中的信息
 }),
  },
  data() {
    return {
      formLabelWidth: '100px',
      dialogVisible: false,
      formdata: {
      },
      checkList: ['姓名', '学校', '班级', '考号'],
      allBaiscsListMap: {
        '姓名': 1,
        '学校': 2,
        '班级': 3,
        '考号': 4,
        '考场': 5,
        '座位': 6,
        '专业': 7,
      }
    }
  },
  methods: {
    ...mapMutations({
      setBasicsCheckList: "card/setBasicsCheckList",
    }),
    handleCancel() {
      this.dialogVisible = false;
    },
    handleSubmit() {
      if(this.checkList.length < 3) {
        return this.$message({
          type: 'warning',
          message: '至少选择3项'
        })
      } else if(this.checkList.length > 5) {
        return this.$message({
          type: 'warning',
          message: '最多选择5项'
        })
      }
      this.dialogVisible = false;
      this.checkList = this.checkList.sort((a, b) => {
        return this.allBaiscsListMap[a] - this.allBaiscsListMap[b];
      })
      this.setBasicsCheckList(this.checkList)
    },
    closeDialog(){
        this.$emit('input', false);
    },
  },
  watch: {
    value(newVal) {
      if(newVal) {
        this.dialogVisible = true;
      }
    },
    basicsCheckList(list) {
      if(list) {
        this.checkList = list;
      }
    }
  },
  mounted() {
    // console.log(this.basicsCheckList, 'basicsCheckList');
    this.checkList = this.basicsCheckList || ['姓名', '学校', '班级', '考号'];
  }
}
</script>

<style lang="scss" >
.modal-basics-info{
.el-select .el-input{
  width: 300px !important;
}
.el-input-group__append{
  background-color: #66b1ff;
  color: #fff;
  border: 1px solid #66b1ff;
}
}

</style>